import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import CreateForecastTypeWizard from 'ui-deal-management-components-lib/components/createForecastTypeWizard/CreateForecastTypeWizard';
import { getProperties } from '../../selectors/properties';
import { getForecastTypes } from '../../selectors/forecastSelectors';
import { getIsCreateForecastTypeWizardOpen } from '../../selectors/wizardSelectors';
import { setIsCreateForecastTypeWizardOpen } from '../../actions/WizardActions';
import { fetchForecastTypes } from '../../actions/ForecastActions';
import { FILTERS } from '../../constants/FiltersConstants';
import { setFilter } from '../../actions/FiltersActions';
import { fetchProperties } from '../../actions/PropertiesActions';
import { logRavenException } from 'ui-deal-management-components-lib/utils/ravenWrapperUtil';
import { trackForecastTypeWizard } from '../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
// This wrapper is used to handle the open/closed state of the wizard in each place it's rendered
export const CreateForecastTypeWizardWrapper = ({
  handleCancelWizard
}) => {
  var _window;
  const dispatch = useDispatch();
  const history = useHistory();
  const isCreateForecastWizardOpen = useSelector(getIsCreateForecastTypeWizardOpen);
  const properties = useSelector(getProperties);
  const forecastTypes = useSelector(getForecastTypes);
  const dealPropertiesArray = Object.values(properties);
  const isCreateForecastRoute = (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.pathname.includes('/create-forecast');
  const handleClickCloseWizard = () => {
    if (isCreateForecastRoute) {
      history.push('/');
    }
    dispatch(setIsCreateForecastTypeWizardOpen(false));
  };
  const handleForecastTypeCreated = useCallback(forecastTypeId => {
    void dispatch(setFilter({
      filter: FILTERS.FORECAST_TYPE,
      value: forecastTypeId
    }));
  }, [dispatch]);
  const handleCreateForecastType = forecastTypeId => {
    dispatch(fetchForecastTypes()).catch(() => {
      // caught and handled in fetchForecastTypes action
    });
    if (forecastTypeId) {
      handleForecastTypeCreated(forecastTypeId);
    }
  };
  useEffect(() => {
    if (isCreateForecastRoute) {
      dispatch(fetchProperties()).catch(error => logRavenException(error, 'fetch properties'));
      dispatch(setIsCreateForecastTypeWizardOpen(true));
    }
  }, [dispatch, isCreateForecastRoute]);
  if (isCreateForecastWizardOpen) {
    return /*#__PURE__*/_jsx(CreateForecastTypeWizard, {
      dealProperties: dealPropertiesArray,
      forecastTypes: forecastTypes,
      onCloseWizard: handleClickCloseWizard,
      onCancelWizard: handleCancelWizard,
      onCreateForecastType: handleCreateForecastType,
      onTrack: trackForecastTypeWizard
    });
  }
  return null;
};